<p-datepicker
  [inline]="true"
  [ngModel]="value"
  (ngModelChange)="onModelChange($event)"
  [minDate]="minDate"
  [maxDate]="maxDate"
  [showOtherMonths]="true"
  [selectOtherMonths]="false">
</p-datepicker>
